import { useMutation } from '@tanstack/react-query';
import { POST, POST_CHECK_BARCODE } from '../../../services';
import { openAlert } from '../../../components/alert/hooks';

export const useCheckBarcode = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (values) => {
      const payload = {
        barcodeValue: values.barcodeValue,
      };
      const response = await POST(POST_CHECK_BARCODE(), payload);
      return response;
    },
    onSuccess: (response) => {
      openAlert({
        model: 'message',
        type: 'success',
        message: response?.message,
      });
    },
    onError: (error) => {
      openAlert({
        model: 'message',
        type: 'error',
        message: error?.message,
      });
    },
  });

  return {
    mutate,
    isPending,
  };
};
